module.exports = __webpack_public_path__ + "867c79a6a43af1688fa57f387ba794d2.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/news3-thumb.jpg
 ** module id = 517
 ** module chunks = 1
 **/